<main class="thp-container">
  <app-talent-happy-path-header [headerOverlineText]="'talent-happy-path.quick-apply.header-overline-text' | translate"
    [headerText]="jobTitle ? jobTitle : 'talent-happy-path.welcome-text' | translate"></app-talent-happy-path-header>
  <div class="thp-container-body" *ngIf="pageLoading">
    <div class="spinner-container">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
  </div>
  <div class="thp-container-body" *ngIf="!pageLoading">
    <div class="progress-bar">
      <mat-progress-bar mode="determinate"[value]="getCompletionPercentage()"></mat-progress-bar>
      <p class="progress-bar-description">
        {{this.getActivePageNumber()}} {{'talent-happy-path.talent-profile.progress-bar-description.of' | translate}} {{totalPages}} {{'talent-happy-path.talent-profile.progress-bar-description.sections' | translate}}
      </p>
    </div>
    <app-vms-submittal-right-to-represent *ngIf="activePage === VmsSubmittalPage.RIGHT_TO_REPRESENT && this.clientVMSSubInfo"
                                          (pageLoading)="onLoadingChange($event)"
                                          [clientVMSSubInfo]="clientVMSSubInfo"
    ></app-vms-submittal-right-to-represent>
    <app-vms-submittal-candidate-validation *ngIf="activePage === VmsSubmittalPage.CANDIDATE_VALIDATION && this.clientVMSSubInfo"
                                            (pageLoading)="onLoadingChange($event)"
                                            [clientVMSSubInfo]="clientVMSSubInfo"
                                            ></app-vms-submittal-candidate-validation>
    <app-vms-submittal-employment-history-and-relationship *ngIf="activePage === VmsSubmittalPage.EMPLOYMENT_HISTORY_AND_RELATIONSHIP_DISCLOSURE && this.clientVMSSubInfo"
                                          [clientEmploymentHistory]="clientVMSSubInfo.clientEmploymentHistory"
                                          [clientName]="clientVMSSubInfo.vmsClientName"
                                          [clientVmsSubInfo]="clientVMSSubInfo"
                                          [personId]="this.talent.personId"
                                          (pageLoading)="onLoadingChange($event)"
    ></app-vms-submittal-employment-history-and-relationship>

    <router-outlet></router-outlet>
  </div>
  <app-talent-happy-path-footer class="thp-footer"></app-talent-happy-path-footer>
</main>
